<template>
  <div class="room-member h-outer-border around-4 bw2 h-bg blue-2 bz0"
       :class="[`mode-${roomInfo.draftMode}`]">
    <div class="flag">
      <div v-show="player.id" class="flag-icon" :class="[`color-${player.color}`]"></div>
    </div>
    <div class="nick" :class="[player.id ? '' : 'nick-placeholder']">
      <template v-if="player.id">
        {{ player.nick }}
        <!-- 房主 -->
        <span v-if="isRoomOwner" class="owner-text ml-1">房主</span>
      </template>
      <template v-else>
        等待加入...
      </template>
    </div>
    <div class="misc">
      <!--  选择角色 -->
      <button v-click-sound-button
              v-if="isPlayer && roomInfo.draftMode === 1"
              class="h-btn ADOPB1TN btn-select-role"
              @click.stop="handleSelectRole">
        <span>选择角色</span>
      </button>

      <!-- 选择配置 -->
      <button v-click-sound-button
              v-if="freeConfigBtnShow"
              class="h-btn ADOPB1TN btn-select-role"
              @click.stop="handleSelectConfig">
        <span>选择配置</span>
      </button>

      <!-- 添加电脑 -->
      <button v-if="addAIShow"
              v-click-sound-button
              class="h-btn normal small btn-add-ai"
              :disabled="isSpectator"
              @click.stop="handleAddAI">
        <span>添加电脑</span>
      </button>

      <div v-if="player.id" class="prepare-status" :class="{already: player.status === 1}">
        {{ PLAYER_STATUS[player.status] }}

        <div v-if="player.isAI && !isSpectator"
             v-click-sound-button
             class="remove-btn h-title nowrap"
             data-title="移除"
             @click="handleRemoveAI">×
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  const PLAYER_STATUS = {
    0: '未准备',
    1: '已准备',
  }

  export default {
    data () {
      return {
        PLAYER_STATUS,
      }
    },

    props: {
      player: {
        type: Object,
        default () {
          return {}
        },
      },

      flag: {
        type: Number,
        default: 1,
      },
    },

    computed: {
      ...mapGetters('user', [
        'userInfo',
      ]),

      ...mapGetters('gameSocket', [
        'roomInfo',
      ]),


      isPlayer () {
        return this.player.userId === this.userInfo.id
      },

      isRoomOwner () {
        return this.roomInfo.ownerUID === this.player.userId
      },

      isSpectator () {
        return this.roomInfo.spectators.some((p) => {
          return p.userId === this.userInfo.id
        })
      },

      addAIShow () {
        return this.roomInfo.ownerUID === this.userInfo.id && !this.player.id
      },

      freeConfigBtnShow () {
        return this.roomInfo.draftMode === 2
          && (this.player.isAI && !this.isSpectator || this.isPlayer)
      },
    },

    methods: {
      handleAddAI () {
        if (this.roomInfo.pvpBounty) {
          this.$emit('alert', '已设置悬赏金，无法添加电脑')
          return
        }
        this.$emit('addAI')
      },

      handleRemoveAI () {
        this.$emit('removeAI')
      },

      handleSelectRole () {
        this.$emit('showRolePopup')
      },

      handleSelectConfig () {
        this.$emit('showFreeConfigPopup', this.player.isAI)
      },
    },
  }
</script>

<style lang="stylus" scoped>
  .room-member
    display flex
    margin-top -3px
    padding 2px
    height 40px
    line-height 32px
    font-size 12px
    color #fff
    > div
      position relative
      text-align center
    .flag
      display flex
      justify-content center
      align-items center
      width 30px
      .flag-icon
        width 24px
        height 29px
        background-repeat no-repeat
        background-size 100%
        &.color-1
          background-image uiURL("VWSYMT0L.png")
        &.color-2
          background-image uiURL("VWSYMT1G.png")
        &.color-3
          background-image uiURL("VWSYMT4B.png")
        &.color-4
          background-image uiURL("VWSYMT5P.png")
        &.color-5
          background-image uiURL("VWSYMT7K.png")
        &.color-6
          background-image uiURL("VWSYMT3D.png")
        &.color-7
          background-image uiURL("VWSYMT2R.png")
        &.color-8
          background-image uiURL("VWSYMT6W.png")
    .nick
      width 120px
      padding 0 5px
      text-align left
      .owner-text
        line-height 12px
        font-size 12px
        goldText1()
      &.nick-placeholder
        opacity 0.5
  .misc
    display flex
    align-items center
    justify-content flex-end
    width calc(100% - 150px)
    padding 0 5px
    > *
      width 56px !important
    > *:not(:first-child)
      margin-left 5px

  .prepare-status
    display flex
    align-items center
    justify-content flex-end
    color $colorRed1
    text-shadow 1px 1px 1px #000
    &.already
      color $colorGreen
      text-shadow 1px 1px 1px #000

  .btn-add-ai
    > span
      display block
      font-size 12px
      letter-spacing 0
      transform-origin center
      transform scale(0.833)

  .btn-select-role
    width 56px
    height 24px
    > span
      display block
      font-size 12px
      letter-spacing 0
      transform-origin center
      transform scale(0.833)
      whiteText1()

  .remove-btn
    z-index 1
    margin-left 2px
    width 16px
    height 16px
    border 1px solid #78624a
    border-radius 2px
    line-height 14px
    text-align center
    font-size 14px
    background-color #392519
    user-select none
    goldText1()
    &:hover
      cursor pointer
      border-color lighten(#78624a, 10%)
      color darken($colorGold, 30%)

</style>
